import PropTypes from 'prop-types';
// material-ui
import Chip from '@mui/material/Chip';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

// project imports
import MainCard from 'components/MainCard';

// assets
import RiseOutlined from '@ant-design/icons/RiseOutlined';
import FallOutlined from '@ant-design/icons/FallOutlined';

const iconSX = { fontSize: '0.75rem', color: 'inherit', marginLeft: 0, marginRight: 0 };

export default function AnalyticEcommerce({ color = 'primary', title, count, percentage, isLoss, extra, footer }) {
  return (
    <MainCard contentSX={{ p: { xs: 2, sm: 2.25 } }} sx={{ height: '100%' }}>
      <Stack sx={{ gap: 0.5 }}>
        <Typography variant="h6" color="text.secondary" sx={{ overflowWrap: 'anywhere' }}>
          {title}
        </Typography>
        <Grid container spacing={1} sx={{ alignItems: 'center', minWidth: 0 }}>
          <Grid sx={{ minWidth: 0, flex: '1 1 auto' }}>
            <Typography variant="h4" color="inherit" sx={{ overflowWrap: 'anywhere', lineHeight: 1.25 }}>
              {count}
            </Typography>
          </Grid>
          {percentage !== undefined && percentage !== null && (
            <Grid sx={{ flex: '0 0 auto' }}>
              <Chip
                variant="combined"
                color={color}
                icon={isLoss ? <FallOutlined style={iconSX} /> : <RiseOutlined style={iconSX} />}
                label={`${percentage}%`}
                sx={{ pl: 1 }}
                size="small"
              />
            </Grid>
          )}
        </Grid>
      </Stack>
      {(footer || extra) && (
        <Box sx={{ pt: 2.25 }}>
          {footer || (
            <Typography variant="caption" color="text.secondary">
              You made an extra{' '}
              <Typography variant="caption" sx={{ color: `${color || 'primary'}.main` }}>
                {extra}
              </Typography>{' '}
              this year
            </Typography>
          )}
        </Box>
      )}
    </MainCard>
  );
}

AnalyticEcommerce.propTypes = {
  color: PropTypes.string,
  title: PropTypes.string,
  count: PropTypes.node,
  percentage: PropTypes.number,
  isLoss: PropTypes.bool,
  extra: PropTypes.node,
  footer: PropTypes.node
};
